<template>
  <div class="row">
    <div class="col-md-10">
      <slot v-if="showContent"></slot>
      <slot v-else name="default-content"></slot>
    </div>
    <v-switch v-model="showContent" hide-details class="col-md-1" @change="onChange"></v-switch>
  </div>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: true }
  },
  data() {
    return {
      showContent: this.show
    }
  },
  watch: {
    show() {
      this.showContent = this.show
    }
  },
  methods: {
    onChange() {
      this.$emit('change', this.showContent)
    }
  }
}
</script>
